const lastWidth = { current: undefined }

/** Match the account row and sit 1px above it (overrides the side-menu paper). */
export function accountMenuPaperSx(anchorEl) {
  if (anchorEl instanceof HTMLElement) lastWidth.current = anchorEl.offsetWidth
  const width = lastWidth.current
  return {
    width: width ?? '100%',
    minWidth: width ?? '240px',
    maxWidth: width ?? 'none',
    marginLeft: 0,
    marginBottom: '1px',
    '& .MuiList-root': {
      display: 'flex',
      flexDirection: 'column',
      gap: '1px',
      padding: 0,
    },
    '& .MuiMenuItem-root': {
      margin: 0,
    },
  }
}
